export const search = (data, key, value) => {
  return data.filter(v => v[key].toLowerCase().includes(value.toLowerCase()));
}